"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Get = exports.Register = exports.Abstract = void 0;
const Store_1 = require("../../Store");
const actions = require("./actions");
class Abstract {
    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.selectors = new Map([
            [
                'state',
                (state, rootState) => {
                    let isProcessing = false;
                    let errorMessage = null;
                    if (rootState.plugins.isProcessing.has(this.key)) {
                        isProcessing = rootState.plugins.isProcessing.get(this.key);
                    }
                    if (rootState.plugins.errorMessage.has(this.key)) {
                        errorMessage = rootState.plugins.errorMessage.get(this.key);
                    }
                    return { isProcessing, errorMessage };
                }
            ]
        ]);
    }
    selector(key, props = {}) {
        if (!this.selectors.has(key)) {
            throw new Error('invalid selector name');
        }
        return (rootState) => {
            return this.selectors.get(key)(this._getPluginStateFromRootState(rootState), rootState, props);
        };
    }
    dispatchRequest() {
        this.dispatch(actions.updateRequest(this.key));
    }
    dispatchFailure(errorMessage) {
        this.dispatch(actions.updateFailure(this.key, errorMessage));
    }
    dispatchSuccess(state) {
        this.dispatch(actions.updateSuccess(this.key, state));
    }
    dispatch(message) {
        this.useDispatch()(message);
    }
    useDispatch() {
        return Store_1.store.dispatch;
    }
    updateState(func) {
        const oldState = this._getPluginStateFromRootState(Store_1.store.getState());
        const newState = func(oldState);
        this.dispatchSuccess(newState);
    }
    _getPluginStateFromRootState(rootState) {
        return rootState.plugins.state.has(this.key)
            ? rootState.plugins.state.get(this.key)
            : {};
    }
}
exports.Abstract = Abstract;
const Plugins = new Map();
function Register(e) {
    if (Plugins.has(e.key)) {
        throw new Error('can not register plugin, key already being used');
    }
    Plugins.set(e.key, e);
    return e;
}
exports.Register = Register;
function Get(key) {
    if (!Plugins.has(key)) {
        throw new Error('can not get plugin, does not exists');
    }
    return Plugins.get(key);
}
exports.Get = Get;
//# sourceMappingURL=repository.js.map